import React, {useState} from 'react';
import {
  StyledModalFileLink,
  UploadModalActions,
  UploadModalApplyBtn,
  UploadModalCancelBtn,
  UploadModalDescr,
  UploadModalTitle,
  UploadModalWrapper,
} from '../../../ui-kit/Modal/styles';
import {WrapperLinks, QuestionCircleStyled, SizeContent, WideButton, MoreInfoRow} from './styles';
import {FileUpload} from '../../../ui-kit/Input/FileUpload';
import {CodeCreateFields} from '../../../types/codes';
import {UploadFile} from 'antd/lib/upload/interface';
import {getModalText} from '../../../helpers/upload';
import {links} from './OnboardingModals';

type UploadModalPropsT = {
  setFiles?: (files: any) => void;
  onAdd?: (value: any[]) => void; // delete this after UploadModal change as UploadEmailsModal
  onUpload?: (value: any[], onSuccess?: () => void) => void; // delete this after UploadModal change as UploadEmailsModal
  onCancel: () => void;
  id?: string | undefined; // delete ? after UploadModal change as UploadEmailsModal
  fullRefetch?: () => void; // delete ? after UploadModal change as UploadEmailsModal
  titleName?: string;
};
export const UploadModal: React.FC<UploadModalPropsT> = ({onAdd, onCancel, titleName}) => {
  const [fileList, setFileList] = useState([]);
  const [fileTypeError, setFileTypeError] = useState(false);

  const resetError = () => setFileTypeError(false);
  const props = {
    onRemove: (file: any) => {
      // eslint-disable-next-line
      //@ts-ignore
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
      setFileTypeError(false);
    },
    // eslint-disable-next-line
    //@ts-ignore
    beforeUpload: (file) => {
      setFileTypeError(false);
      if (file.type !== 'text/csv') {
        setFileTypeError(true);
        return false;
      }
      // eslint-disable-next-line
      //@ts-ignore
      setFileList([...fileList, file]);
      return false;
    },
    error: fileTypeError
      ? {
          title: 'Invalid file uploaded. Please try again.',
          descr: `Please make sure it's a CSV or Numbers file and properly formatted`,
        }
      : null,
    fileList,
    accept: '.csv',
    name: CodeCreateFields.promoCodes,
  };
  const apply = () => {
    onAdd?.(fileList);
  };
  return (
    <UploadModalWrapper>
      <UploadModalTitle>Add New Codes for {titleName}</UploadModalTitle>
      <UploadModalDescr>Please add your additonal codes by uploading a CSV file.</UploadModalDescr>
      <FileUpload woTheme={true} onResultClick={resetError} {...props} />
      <UploadModalActions>
        <UploadModalCancelBtn onClick={onCancel}>Cancel</UploadModalCancelBtn>
        <UploadModalApplyBtn disabled={!fileList?.length} onClick={apply}>
          Add New Codes
        </UploadModalApplyBtn>
      </UploadModalActions>
    </UploadModalWrapper>
  );
};

type UploadModalEmailsPropsT = {
  setFiles?: (files: any) => void;
  onAdd: (value: any[]) => Promise<any>;
  onCancel: () => void;
  onUploadSuccess: () => void;
  uploadTriggered?: boolean;
  isOnboarding?: boolean;
};

export const UploadModalEmails: React.FC<UploadModalEmailsPropsT> = ({
  onAdd,
  onCancel,
  uploadTriggered,
  onUploadSuccess,
  isOnboarding,
}) => {
  const [fileList, setFileList] = useState<any[]>([]);
  const [fileTypeError, setFileTypeError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [totalUploaded, setTotalUploaded] = useState(0);
  const [error, setError] = useState('');

  const resetError = () => {
    setFileTypeError(false);
    setError('');
    setFileList([]);
  };
  const props = {
    onRemove: (file: any) => {
      // eslint-disable-next-line
      //@ts-ignore
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
      setFileTypeError(false);
    },
    // eslint-disable-next-line
    //@ts-ignore
    beforeUpload: (file) => {
      setFileTypeError(false);
      if (file.type !== 'text/csv' && !(file.name as string).includes('.numbers')) {
        setFileTypeError(true);
        return false;
      }
      setFileList((prev) => [...prev, file]);
      return false;
    },
    fileList,
    accept: '.csv, .numbers',
    name: 'emails',
  };

  const apply = async () => {
    setError('');
    setSuccess(false);
    setLoading(true);
    const res = await onAdd?.(fileList);
    console.log(res);
    if (res?.success) {
      setSuccess(true);
      setTotalUploaded(res?.total);
    }
    if (res?.error) setError(res?.error?.message);
    setLoading(false);
  };

  const {ppTitle, uploadError, uploadSuccess, typeError, cancelText, uploadText} = getModalText({
    uploadTriggered,
    isOnboarding,
    success,
    error,
    fileTypeError,
    totalUploaded,
  });
  return (
    <UploadModalWrapper>
      <UploadModalTitle>{ppTitle}</UploadModalTitle>

      <FileUpload
        woTheme={true}
        onResultClick={resetError}
        descr="Upload a contact file in .csv or .numbers format.
        File must have contact data in the following columns: name, email, quantity. All contacts must be listed in separate rows."
        title="Drag and drop a file here or click the icon to choose one"
        success={uploadSuccess}
        loading={loading}
        error={uploadError || typeError}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        itemRender={(originNode, file) => <UploadListItem originNode={originNode} file={file} />}
        {...props}
      />
      {!uploadTriggered && !success && (
        <WrapperLinks>
          <UploadModalDescr>
            Download the CSV template:{' '}
            <StyledModalFileLink href="https://storage.googleapis.com/enc-assets/portals/promo_code_guests.csv">
              enchant-csv-email-template.csv
            </StyledModalFileLink>
          </UploadModalDescr>
          <StyledModalFileLink
            target="_blank"
            href="https://enchantlabs.notion.site/CSV-Guide-for-Codes-Distribution-c15b083560e14336ad4124a34860f833">
            <QuestionCircleStyled />
          </StyledModalFileLink>
        </WrapperLinks>
      )}
      {!success ? (
        <>
          <UploadModalActions>
            <UploadModalCancelBtn onClick={onCancel}>{cancelText}</UploadModalCancelBtn>
            <UploadModalApplyBtn onClick={apply} disabled={!fileList?.length}>
              {uploadText}
            </UploadModalApplyBtn>
          </UploadModalActions>
          <MoreInfoRow>
            <b>Need more info? </b>{' '}
            <a href={links.more} target="_blank" rel="noreferrer">
              Visit our help resource
            </a>
          </MoreInfoRow>
        </>
      ) : (
        <WideButton onClick={onUploadSuccess}>Continue</WideButton>
      )}
    </UploadModalWrapper>
  );
};

interface UploadListItemProps {
  originNode: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
  file: UploadFile<any>;
}

const UploadListItem = ({originNode, file}: UploadListItemProps) => {
  const size = `${file?.size} KB`;
  return <SizeContent size={size}>{originNode}</SizeContent>;
};
